export const APP_LOAD_ERROR_FLOW = 'app-load';
